import { DateValue } from "../model/date-value.type";

export function toValue(value: undefined | null | boolean | number | Date | string): string {
    if (value === undefined || value === null)
        return '';
    if (typeof value === 'boolean')
        return toBooleanValue(value);
    if (typeof value === 'number')
        return toNumberValue(value);
    if (value instanceof Date)
        return toDateValue(value);
    if (typeof value === 'string')
        return toTextValue(value);
    return '';
}

export function toBooleanValue(value: undefined | null | boolean): string {
    return value ? 'true' : 'false';
}

export function toNumberValue(value: undefined | null | number): string {
    if (value === undefined || value === null)
        return '';
    return value.toString();
}

export function toDateValue(value: undefined | null | DateValue): string {
    if (value === undefined || value === null)
        return '';
    const date = new Date(value);
    return date.toISOString();
}

export function toTextValue(value: undefined | null | string): string {
    if (value === undefined || value === null)
        return '';
    return value;
}
